module.exports = __webpack_public_path__ + "static/media/marker-courier-empty.8e792eaf.png";